<template>
  <div class="p-2">
    <wui-form-row
      v-if="isRetryDaysVisible"
      :label-width="4"
      :input-width="8"
    >
      <template #label>
        <span class="text-1316">
          {{ everyStr }}
        </span>
      </template>
      <template #input>
        <div class="flex items-center gap-2 h-12">
          <wui-input
            v-model="model.repeatDays"
            maxlength="6"
            allowed-reg-exp="\d"
          />
          <span class="text-1316">{{ retryDaysStr }}</span>
        </div>
      </template>
    </wui-form-row>
    <wui-form-row
      :label-width="4"
      :input-width="8"
    >
      <template #label>
        <span class="text-1316">
          {{ t('common.repeatTimes') }}
        </span>
      </template>
      <template #input>
        <wui-select
          v-model="model.repeat"
          :items="retryOptions"
          class="[&_.wui-select__field]:bg-white"
          :size="32"
        />
      </template>
    </wui-form-row>
  </div>
</template>

<script lang="ts" setup>
import { WuiInput, WuiFormRow, WuiSelect, SelectItem } from '@wui/common-library'
import { computed } from 'vue'

import { useLocalization } from '@/shared/composables/localization'
import { capitalize } from '@/shared/utils/capitalize-string'

import type { Repeat, RepeatOptions } from '../types'

defineProps<{
  isRetryDaysVisible?: boolean
}>()

const model = defineModel<RepeatOptions>({
  default: () => ({ repeatDays: 1, repeat: 'week' }),
})

const { t, tc } = useLocalization()

const retryDaysStr = computed(() => {
  return tc('common.days', +model.value.repeatDays)
})
const everyStr = computed(() => {
  return tc('common.every', +model.value.repeatDays)
})

const retryOptions: SelectItem<Repeat>[] = [
  {
    label: capitalize(tc('common.week', 2)),
    value: 'week',
  },
  {
    label: t('common.month'),
    value: 'month',
  },
  {
    label: t('common.year'),
    value: 'always',
  },
]
</script>
